export function formatDateTime(date: string): string {
  if (!date) return '---'
  return new Date(date).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatTime(time: number): string {
  const hour = Math.floor(time / 60)
  const minute = time % 60

  let formatTime = ''
  if (hour > 0) {
    formatTime += `${hour} hora${hour > 1 ? 's' : ''}`
    if (minute > 0) {
      formatTime += ' e '
    }
  }
  if (minute > 0) {
    formatTime += `${minute} minuto${minute > 1 ? 's' : ''}`
  }

  return formatTime
}
